import ModalForms from "./modal/ModalForms";

class App {
  constructor() {
    this.init();
    console.log('create App.js');

  }

  init = () => {

    this.initAfterDocumentLoaded();
  }

  initAfterDocumentLoaded = () => {
    addEventListener("DOMContentLoaded", (event) => {
      this.modalForms = new ModalForms();
      this.initBurgerMenu();

      console.log('init app sync')
    });
  }

  initBurgerMenu = () => {
    const btnBurger = document.getElementById('btn-burger');
    const burgerMenu = document.getElementById('burger-menu');

    btnBurger.addEventListener('click', (e) => {
      document.body.classList.toggle('modal-mode');
      burgerMenu.classList.toggle('show');
    });

    const menuLvl1Headings = document.querySelectorAll('.burger-menu__lvl1_heading');

    [...menuLvl1Headings].forEach(heading => {

      heading.addEventListener('click', (e) => {
        heading.parentNode.classList.toggle('active');
      });
    });


  }

}

export default App;



